export default {
    props: {
        plotAreaBackground: {
            type: String,
            default: undefined,
            kComposite: 'plotArea.background'
        }, 
        plotAreaOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.opacity'
        }, 
        plotAreaBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'plotArea.border.color'
        }, 
        plotAreaBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'plotArea.border.dashType'
        }, 
        plotAreaBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'plotArea.border.width'
        }, 
        plotAreaMargin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'plotArea.margin'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/PlotArea.js